import { ReactNode, SyntheticEvent } from 'react';

import { cn } from '@/utils/lib/utils';
import { ArrowUpRight } from '@/utils/lucide';
//Icon Options
import { ExternalLink } from '@/utils/lucide';
import { Share } from '@/utils/lucide';
import openDetail from '@/utils/openDetail';

interface OpenableTitleProps
{
	title: string;
	id: string;
	type?: string;
	pre?: ReactNode;
	className?: string;
	noIcon?: boolean;
	outerClassName?: string;
}

const OpenableTitle = ({ title, id, type, pre, className, noIcon, outerClassName }: OpenableTitleProps) =>
{
	const onClick = (e: SyntheticEvent) =>
	{
		openDetail(e, id, type);
	};

	return (
		<div onAuxClick={onClick} className={cn('flex flex-row items-center gap-x-2', outerClassName)}>
			{pre}
			<div className={cn('flex flex-row items-center gap-x-2 group cursor-pointer', className)} onClick={onClick} data-pw='openable-title'>
				<span className='group-hover:underline'>{title}</span>
				{!noIcon && (
					<span className='text-gray-400 group-hover:text-gray-700 text-icon'>
						<ExternalLink />
					</span>
				)}
			</div>
		</div>
	);
};

export default OpenableTitle;
